import { render, staticRenderFns } from "./ModalUserDetails.vue?vue&type=template&id=c04faa4a&"
import script from "./ModalUserDetails.vue?vue&type=script&lang=js&"
export * from "./ModalUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports